import React from "react";
import "./PlayIon.scss";
const PlayIcon = ({width, height, fill}) =>{
    return <svg className={"play-icon-svg"} width={width} height={height} viewBox="0 0 24 24">
        <path fill="#fff" d="M8,5.14V19.14L19,12.14L8,5.14Z" />

        <path fill={fill} d="M10,16.5V7.5L16,12M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" />
    </svg>
}

PlayIcon.defaultProps={
    width:24,
    height: 24,
    fill: undefined
};

export default PlayIcon;
